import React from 'react';
import { Route } from 'react-router-dom';
import {
  ComplexAreaListPage,
  ComplexAreaListV2Page,
  ComplexAreaMapPage,
  ComplexDetailPage,
  ComplexListPage,
  EducationMapPage,
  EnvironmentMapPage,
  FrontYardCreatePage,
  FrontYardDetailPage,
  FrontYardListPage,
  LivingAreaCreatePage,
  LivingAreaDetailPage,
  LivingAreaListPage,
  RealEstatePage
} from './component/realestate/page';

const RouteGroupRealEstate = () => {
  return (
    <>
      <Route exact path={"/realestate"} component={RealEstatePage} />
      <Route exact path={"/realestate/frontyard"} component={FrontYardListPage} />
      <Route exact path={"/realestate/frontyard/new"} component={FrontYardCreatePage} />
      <Route exact path={"/realestate/frontyard/:frontYardId([0-9]+)"} component={FrontYardDetailPage} />
      <Route exact path={"/realestate/livingarea"} component={LivingAreaListPage} />
      <Route exact path={"/realestate/livingarea/new"} component={LivingAreaCreatePage} />
      <Route exact path={"/realestate/livingarea/:livingAreaId([0-9]+)"} component={LivingAreaDetailPage} />
      <Route exact path={"/realestate/environment-map"} component={EnvironmentMapPage} />
      <Route exact path={"/realestate/education-map"} component={EducationMapPage} />
      <Route exact path={"/realestate/complex"} component={ComplexListPage} />
      <Route exact path={"/realestate/complex/:complexId([0-9]+)"} component={ComplexDetailPage} />
      <Route exact path={"/realestate/complex-area"} component={ComplexAreaListPage} />
      <Route exact path={"/realestate/complex-area2"} component={ComplexAreaListV2Page} />
      <Route exact path={"/realestate/complex-area-map"} component={ComplexAreaMapPage} />
    </>
  );
}

export { RouteGroupRealEstate };
